/* eslint-disable no-console */

import $ from 'jquery';

// Update triggers with Plausible props
// ----------------------------------------------------------------
export function updateTriggerOnClickFunctionalityWithPlausibleProps()
{
  let logging = false;

  let form = document.querySelector('form');

  // let language = navigator.language || navigator.userLanguage;
  let language = document.documentElement.lang;

  let donationType = '';
  let donationAmount = 0;
  let donationAmountOtherSum = document.querySelector('input[name="donation-amount-other"]');
  let donationPaymentType = '';
  let donationSelectedBank  = '';

  if (form) {
    if (logging) { console.log('Form:', form) }

    let inputs = $(form).find('input');
    for (let i = 0; i < inputs.length; i++) {
      if (logging) { 'Inputs:', console.log(inputs[i]) }

      // Step 1:
      // ----------------------------------------------------------------

        // Get input type
        // ----------------------------------------------------------------
        if (
          inputs[i].name === 'donation-type' &&
          inputs[i].checked === true
        ) { donationType = inputs[i].value; }
        if (logging) { console.log('Donation type:', donationType) }

        // Get input amount
        // ----------------------------------------------------------------
        if (
          inputs[i].name === 'donation-amount' &&
          inputs[i].checked === true
        ) {
          if (inputs[i].classList.contains('js-donationOtherSumTrigger')) {
            // Gets donation amount if "Other sum" is chosen.
            donationAmount = donationAmountOtherSum.value;
          } else {
            donationAmount = inputs[i].value;
          }
        }

        if (logging) { console.log('Donation amount:', donationAmount) }

      // Step 2:
      // ----------------------------------------------------------------

      // Step 3 (Submission):
      // ----------------------------------------------------------------
        if (
          inputs[i].name === 'donation-payment-method' &&
          inputs[i].checked === true
        ) {
          if (inputs[i].value === 'verkkopankki') {
            donationPaymentType = 'Bank';
          }
          else if (inputs[i].value === 'korttimaksu') {
            donationPaymentType = 'Card';
          }
        }

        if (logging) { console.log('Donation payment type:', donationPaymentType) }

        if (
          inputs[i].name === 'donation-payment-bank' &&
          inputs[i].checked === true
        ) {
          donationSelectedBank = inputs[i].value;
        }

        if (logging) { console.log('Donation selected bank:', donationSelectedBank) }

      // Assign Plausible props to step and submit triggers.
      // Note that revenue is only present on final step.
      // ----------------------------------------------------------------
      let formDirectionForwardTrigger = document.getElementsByClassName('js-formDirectionForwardTrigger');

      if (formDirectionForwardTrigger.length) {
        for (let i = 0; i < formDirectionForwardTrigger.length; i++) {

          // Get current form step
          // ----------------------------------------------------------------
          let onClickPropStep1 = `window.plausible('Donation Step 1', {props: { donation_type: '${donationType}', language: '${language}', selected_donation_amount: '${donationAmount} €', payment_type: '${donationPaymentType}', selected_bank: '${donationSelectedBank}' } } )`;
          onClickPropStep1 = onClickPropStep1.replace(/"/g, '');
          formDirectionForwardTrigger[0].setAttribute('onClick', onClickPropStep1);

          let onClickPropStep2 = `window.plausible('Donation Step 2', {props: { donation_type: '${donationType}', language: '${language}', selected_donation_amount: '${donationAmount} €', payment_type: '${donationPaymentType}', selected_bank: '${donationSelectedBank}' } } )`;
          onClickPropStep2 = onClickPropStep2.replace(/"/g, '');
          formDirectionForwardTrigger[1].setAttribute('onClick', onClickPropStep2);

          let onClickPropStep3 = `window.plausible('Donation Step 3', {props: { donation_type: '${donationType}', language: '${language}', selected_donation_amount: '${donationAmount} €', payment_type: '${donationPaymentType}', selected_bank: '${donationSelectedBank}' } } )`;
          onClickPropStep3 = onClickPropStep3.replace(/"/g, '');
          formDirectionForwardTrigger[2].setAttribute('onClick', onClickPropStep3);

        }
      }

    }

  }

}
